import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
  setPreferenceIds,
} from '../../../modules/profile/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import ManagePreferencesPage from '../components/ManagePreferencesPage/ManagePreferencesPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState
  const { accessToken } = auth
  const {
    primaryInfo,
    showProfileModal,
    profileModalPage,
    preferenceIds: userPreferenceIds,
  } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    userPreferenceIds,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      setPreferenceIds,
      displayProfileModal,
      setProfileModalPage,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedManagePreferencesPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagePreferencesPage)

export default ConnectedManagePreferencesPage
